import API from './utils/API'

const api = new API()
const prefix = '/standard'

const getPaStandards = ({ pdlIds, paIds }) =>
  api
    .callApi({
      url: `${prefix}/pa-standards`,
      method: 'get',
      params: {
        ...(pdlIds ? { pdlIds: pdlIds.join(',') } : {}),
        ...(paIds ? { paIds: paIds.join(',') } : {}),
      },
    })
    .then((response) => response?.data?.result)

export default {
  getPaStandards,
}
